<template>
    <zk-admin-table title="精准关怀体检审核" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="getData">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center" width="200">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{
                    item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="created" label="申请时间" width="160" align="center" />
        <el-table-column prop="created_by" label="申请人" width="100" align="center" />
        <el-table-column prop="hospital" label="体检机构" width="190" align="center" />
        <el-table-column prop="expert_name" label="研判专家姓名" width="120" align="center" />
        <el-table-column prop="audit_at" label="审核时间" width="160" align="center" />
        <el-table-column prop="audit_by" label="审核人" width="100" align="center" />
        <el-table-column prop="audit_reason" label="审核意见" width="200" align="center" />

        <el-table-column align="center" width="130" label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleAudit(scope.row)"
                    v-if="scope.row.status === 0">审核</el-button>
                <el-button size="mini" @click="handleAudit(scope.row)" v-else>查看</el-button>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog :title="form.status === 0 ? '审核申请单' : '查看申请单'" :visible.sync="dialogVisible"
                :close-on-click-modal="false" fullscreen custom-class="audit-fullscreen-dialog">
                <div class="audit-page">
                    <div class="audit-page-head">
                        <div>
                            <div class="audit-page-title">精准关怀体检审核单</div>
                            <div class="audit-page-subtitle">申请信息仅供查看，审核时请核对准入标准与费用</div>
                        </div>
                        <div class="audit-status">
                            <el-tag v-if="form.status === 0" type="primary">待审核</el-tag>
                            <el-tag v-else-if="form.status === 1" type="success">已审核</el-tag>
                            <el-tag v-else-if="form.status === -1" type="danger">审核不通过</el-tag>
                            <el-tag v-else-if="form.status === 2" type="warning">已收费</el-tag>
                        </div>
                    </div>

                    <div class="audit-page-content">
                        <el-form :model="form" label-width="100px" disabled>
                            <section class="audit-card">
                                <div class="audit-card-title">一、基本信息</div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="员工选择" label-width="100px">
                                            <select-staff v-model="form.staff_id" :disabled="true" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </section>

                            <section class="audit-card" v-if="displayedCriteriaSections.length">
                                <div class="audit-card-title">二、精准关怀项目准入标准</div>
                                <div class="audit-card-desc">仅显示申请时已勾选的项目与条件</div>
                                <div class="criteria-groups">
                                    <div class="criteria-group" v-for="group in displayedCriteriaSections"
                                        :key="group.id">
                                        <div class="criteria-project">
                                            <div class="criteria-project-title">{{ group.project }}</div>
                                            <span class="criteria-project-price">{{ group.price }} 元</span>
                                        </div>
                                        <div class="criteria-label"
                                            v-if="group.requiredSelected && group.requiredSelected.length">必选项</div>
                                        <div class="criteria-options"
                                            v-if="group.requiredSelected && group.requiredSelected.length">
                                            <div class="criteria-item" v-for="requiredItem in group.requiredSelected"
                                                :key="requiredItem.id">
                                                {{ requiredItem.label }}
                                            </div>
                                        </div>
                                        <div class="criteria-label"
                                            v-if="group.optionalSelected && group.optionalSelected.length">
                                            {{ group.optionalRule || '可选项' }}
                                        </div>
                                        <div class="criteria-options criteria-options-grid"
                                            v-if="group.optionalSelected && group.optionalSelected.length">
                                            <div class="criteria-item" v-for="optionalItem in group.optionalSelected"
                                                :key="optionalItem.id">
                                                {{ optionalItem.label }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section class="audit-card" v-if="form.status === -1 && form.audit_reason">
                                <div class="audit-card-title">三、驳回原因</div>
                                <div class="reject-reason">{{ form.audit_reason }}</div>
                            </section>
                        </el-form>
                    </div>

                    <div class="audit-page-footer" v-if="form.status === 0">
                        <div class="footer-tip">审核通过后将不可修改，请谨慎操作。</div>
                        <div class="footer-actions">
                            <el-button type="danger" plain @click="handleReject" :loading="loading">审核不通过</el-button>
                            <el-button type="success" @click="handleApprove" :loading="loading">审核通过</el-button>
                        </div>
                    </div>
                    <div class="audit-page-footer" v-else>
                        <div class="footer-tip">当前申请已完成审核，仅支持查看。</div>
                        <div class="footer-actions">
                            <el-button @click="dialogVisible = false">关 闭</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
import SelectStaff from '../../components/form/selectStaff.vue';

const ADMISSION_STANDARD_SECTIONS = [
    {
        id: 'cta_combo',
        project: '头颈、冠脉二合一CTA',
        price: 1200,
        required: [
            { id: 'cta_combo_req_stenosis', label: '颈动脉狭窄 >= 50%' }
        ]
    },
    {
        id: 'coronary_cta',
        project: '冠脉CTA',
        price: 1200,
        required: [
            { id: 'coronary_cta_req_symptom_plaque', label: '有临床症状 + 颈动脉斑块' }
        ],
        optionalRule: '可选项（必选项 + 下列任选三项）',
        optional: [
            { id: 'coronary_cta_opt_septal_thickening', label: '室间隔厚' },
            { id: 'coronary_cta_opt_left_atrial_enlarge', label: '左室增大' },
            { id: 'coronary_cta_opt_hyperglycemia', label: '血糖升高' },
            { id: 'coronary_cta_opt_bmi_28', label: 'BMI >= 28' },
            { id: 'coronary_cta_opt_hypertension', label: '血压偏高' },
            { id: 'coronary_cta_opt_dyslipidemia', label: '血脂异常' },
            { id: 'coronary_cta_opt_male_age_45', label: '男性年龄 >= 45' }
        ]
    },
    {
        id: 'holter_24h',
        project: '24小时动态心电',
        price: 300,
        required: [
            { id: 'holter_24h_req_arrhythmia', label: '出现明确的室性早搏或心律失常' }
        ]
    },
    {
        id: 'mra_brain',
        project: '颅脑核磁MRA',
        price: 1000,
        required: [
            { id: 'mra_brain_req_plaque', label: '有颈动脉斑块' }
        ],
        optionalRule: '可选项（必选项 + 下列任选三项）',
        optional: [
            { id: 'mra_brain_opt_septal_thickening', label: '室间隔厚' },
            { id: 'mra_brain_opt_left_atrial_enlarge', label: '左室增大' },
            { id: 'mra_brain_opt_hyperglycemia', label: '血糖升高' },
            { id: 'mra_brain_opt_bmi_24', label: 'BMI >= 24' },
            { id: 'mra_brain_opt_hypertension', label: '血压偏高' },
            { id: 'mra_brain_opt_dyslipidemia', label: '血脂异常' },
            { id: 'mra_brain_opt_male_age_45', label: '男性年龄 >= 45' },
            { id: 'mra_brain_opt_severe_athero', label: '重度动脉硬化' }
        ]
    },
    {
        id: 'lung_nodule_analysis',
        project: '肺小结节肿瘤分析',
        price: 400,
        optionalRule: '可选项（二选一）',
        optional: [
            { id: 'lung_nodule_opt_solid', label: '有实性结节或部分实性结节的实性成分，平均直径 >= 6mm 且 < 15mm' },
            { id: 'lung_nodule_opt_non_solid', label: '有非实性结节平均直径 >= 8mm 且 < 15mm 者' }
        ]
    },
    {
        id: 'breast_mammography',
        project: '乳腺钼靶',
        price: 300,
        required: [
            { id: 'breast_mammography_req_birads4', label: '乳腺B超检查结果显示为 BI-RADS 4类及以上' }
        ]
    }
];

export default {
    name: 'keycare_audit',
    path: '/main/keycare/audit',
    components: {
        SelectStaff
    },
    meta: {
        title: '精准关怀体检审核',
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: '0' // Default to pending audit
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            admissionStandardSections: ADMISSION_STANDARD_SECTIONS,
            form: {
                staff_id: null,
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0,
                status: 0,
                expert_name: '',
                hospital: '',
                created: '',
                created_by: '',
                audit_reason: '',
                admission_criteria: []
            }
        }
    },
    computed: {
        displayedCriteriaSections() {
            const selected = new Set(this.form.admission_criteria || []);
            return this.admissionStandardSections
                .map(group => {
                    const requiredSelected = (group.required || []).filter(item => selected.has(item.id));
                    const optionalSelected = (group.optional || []).filter(item => selected.has(item.id));
                    const include = selected.has(group.id) || requiredSelected.length > 0 || optionalSelected.length > 0;
                    if (!include) return null;
                    return Object.assign({}, group, { requiredSelected, optionalSelected });
                })
                .filter(Boolean);
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            try {
                const resp = await this.$http.get('/keycare/register', {
                    params: {
                        page: this.table.page,
                        pageSize: this.table.pageSize,
                        ...this.search
                    }
                });
                this.table.data = resp.data.data;
                this.table.total = resp.data.total;
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleAudit(row) {
            this.form = Object.assign({
                staff_id: null,
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0,
                status: 0,
                expert_name: '',
                hospital: '',
                created: '',
                created_by: '',
                audit_reason: '',
                admission_criteria: []
            }, JSON.parse(JSON.stringify(row)));
            this.dialogVisible = true;
        },
        async handleApprove() {
            this.$confirm('确认审核通过该申请吗？通过后将进入下一环节。', '审核确认', {
                confirmButtonText: '确认通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleSubmit(1);
            }).catch(() => { });
        },
        async handleReject() {
            this.$prompt('请填写审核不通过原因', '审核驳回', {
                confirmButtonText: '确认驳回',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputPlaceholder: '请输入具体驳回原因，便于申请人修改后重新提交',
                inputPattern: /\S+/,
                inputErrorMessage: '驳回原因不能为空'
            }).then(({ value }) => {
                this.handleSubmit(-1, value.trim());
            }).catch(() => { });
        },
        async handleSubmit(status, reason = '') {
            this.loading = true;
            try {
                // Mock audit submission
                // await new Promise(resolve => setTimeout(resolve, 500)); 
                const resp = await this.$http.post('/keycare/audit', { id: this.form.id, status: status, reason });
                if (status === -1) {
                    this.form.audit_reason = reason;
                }
                this.$message[resp.data.status](resp.data.msg);
                if (resp.data.status == 'success') {
                    this.dialogVisible = false;
                    this.getData();
                }
            } catch (e) {
                this.$message.error(e.message || '操作失败');
            }
            this.loading = false;
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
::v-deep .audit-fullscreen-dialog {
    margin-top: 0 !important;
}

::v-deep .audit-fullscreen-dialog .el-dialog__header {
    padding: 14px 20px 12px;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
}

::v-deep .audit-fullscreen-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2f4d;
}

::v-deep .audit-fullscreen-dialog .el-dialog__body {
    padding: 0;
    height: calc(100vh - 56px);
    overflow: hidden;
    background: #f5f7fb;
}

.audit-page {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.audit-page-head {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 24px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
}

.audit-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1f2f4d;
}

.audit-page-subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #7b8794;
}

.audit-page-content {
    flex: 1;
    overflow-y: auto;
    padding: 18px 24px 88px;
}

.audit-card {
    background: #fff;
    border: 1px solid #e9edf2;
    border-radius: 8px;
    padding: 16px 18px 8px;
    margin-bottom: 14px;
}

.audit-card-title {
    font-size: 16px;
    font-weight: 700;
    color: #1f2f4d;
    margin-bottom: 10px;
}

.audit-card-desc {
    margin-top: -4px;
    margin-bottom: 12px;
    color: #7b8794;
    font-size: 12px;
}

.criteria-groups {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 12px;
    background: #fff;
}

.criteria-group {
    padding: 12px 0 14px;
    border-bottom: 1px solid #ebeef5;
}

.criteria-group:last-child {
    border-bottom: none;
    padding-bottom: 8px;
}

.criteria-project {
    margin-bottom: 8px;
    padding: 6px 8px;
    background: #f8fafd;
    border-left: 3px solid #409eff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.criteria-project-price {
    flex-shrink: 0;
    font-size: 14px;
    color: #f56c6c;
    font-weight: 700;
}

.criteria-label {
    margin: 8px 0 6px;
    font-size: 14px;
    font-weight: 600;
    color: #606266;
}

.criteria-options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;
    padding-left: 12px;
}

.criteria-options-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(160px, 1fr));
    gap: 10px 24px;
}

.criteria-item {
    font-size: 14px;
    color: #303133;
    line-height: 1.6;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    position: relative;
    padding-left: 14px;
}

.criteria-item::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #409eff;
    position: absolute;
    left: 0;
    top: 8px;
}

.reject-reason {
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fcfcfd;
    color: #606266;
    line-height: 1.6;
    white-space: pre-wrap;
}

.audit-page-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 8px rgba(31, 45, 61, 0.05);
}

.footer-tip {
    color: #909399;
    font-size: 13px;
}

.footer-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

@media (max-width: 1366px) {
    .criteria-options-grid {
        grid-template-columns: repeat(3, minmax(160px, 1fr));
    }
}

@media (max-width: 1024px) {
    .criteria-options-grid {
        grid-template-columns: repeat(2, minmax(160px, 1fr));
    }
}
</style>
